import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        deliveryOptionRoad: {
            '&&': {
                width: '60%',
                paddingRight: theme.spacing(1),
                boxSizing: 'border-box',
                display: 'inline-block',
            },
        },
        numberOfVehicles: {
            '&&': {
                width: '40%',
                paddingLeft: theme.spacing(1),
                boxSizing: 'border-box',
                display: 'inline-block',
            },
        },
        gridWrapper: {
            display: 'grid',
            gap: theme.spacing(2),
            gridTemplateColumns: 'repeat(1, 1fr)',
        },
    }
})

export default useStyles
